import { TypeStoreDetail } from "@/lib/redux/features/store/type"
import { faFacebook, faInstagramSquare, faTiktok } from "@fortawesome/free-brands-svg-icons"

export const getSocailMediaItems = (store: TypeStoreDetail) => {
  const items = [
    {
      url: store.custom_url?.url,
      icon: store.custom_url?.icon || store.logo,
      type: 'custom_url'
    },
    {
      url: store.facebook?.url,
      icon: store.facebook?.icon || faFacebook,
      type: 'facebook'
    },
    {
      url: store.tiktok?.url,
      icon: store.tiktok?.icon || faTiktok,
      type: 'tiktok'
    },
    {
      url: store.instagram?.url,
      icon: store.instagram?.icon || faInstagramSquare,
      type: 'instagram'
    },
  ].filter(({ icon, url }) => {
    if (!icon || !url) return false
    return true
  })

  return items
}